module.exports = __webpack_public_path__ + "img/3.cff71b65.jpg";